export type Lang = "pt-BR" | "en";

const translations = {
  "pt-BR": {
    nav: {
      liga: "Liga",
      gus: "GUs",
      pessoas: "Pessoas",
      conquistas: "Conquistas",
      rules: "Regras",
      admin: "Admin",
      dashboard: "Dashboard",
      ranking: "Ranking",
      participants: "Participantes",
    },
    header: {
      signOut: "Sair",
      openMenu: "Abrir menu",
      closeMenu: "Fechar menu",
      toggleTheme: "Alternar tema",
      phases: {
        pre: "PRÉ-LANÇAMENTO",
        active: "TEMPORADA EM ANDAMENTO",
        encerrado: "ENCERRADO",
      },
    },
    liga: {
      seasonBadge: "TEMPORADA EM ANDAMENTO",
      title: "AGENTIC LEAGUE.",
      subtitle: "A competição pela transformação agêntica da CI&T",
      heroParticipants: "participantes",
      heroGus: "GUs",
      heroIn: "em",
      heroRegions: "regiões",
      statActive: "ativos",
      statRegions: "regiões",
      statRate: "taxa",
      eligibleLabel: "elegíveis",
      pointsLabel: "pontos",
      certShort: "cert",
      countdownTitle: "Liga encerra em",
      expired: "Liga encerrada — aguardando ranking oficial",
      pre: "Liga começa em {date}",
      countdown: { days: "dias", hours: "h", minutes: "min", seconds: "seg" },
      metrics: {
        participants: "Participantes",
        activeGUs: "GUs Ativas",
        certified: "Pessoas Certificadas",
        totalCertifications: "Total de Certificados",
      },
      podiumTitle: "TOP 3 GUS",
      podiumSubtitle: "Disputa de pontos",
      evolutionTitle: "EVOLUÇÃO DE CERTIFICAÇÕES",
      evolutionSubtitle: "Últimos 60 dias",
      evolutionEmpty: "Sem certificações nos últimos 60 dias.",
      evolutionSeries: { people: "Pessoas Certificadas", certifications: "Total de Certificados" },
      rankingTitle: "RANKING COMPLETO",
      top10Title: "TOP 10",
      viewAll: "Ver todas",
      leaderChip: "Líder absoluta",
      estPrize: "Prêmio est.",
      columns: {
        pos: "Pos", gu: "GU", eligible: "Elegíveis",
        cert: "Cert.", pct: "% Cert.", pts: "Pts GU", prize: "Prêmio",
      },
      pagination: { page: "Pág.", of: "de", prev: "← Ant", next: "Próx →" },
    },
    gus: {
      title: "GROWTH UNITS",
      subtitle: "Performance por GU nesta temporada",
      searchPlaceholder: "Buscar GU…",
      sortLabel: "Ordenar por",
      sortOptions: {
        pts: "Pontos",
        cert: "Certificados",
        pct: "% Taxa",
        name: "Nome",
      },
      tabs: {
        all: "TODAS",
        apac: "APAC",
        na: "NA",
        latam: "LATAM",
        emea: "EMEA",
        ga: "G&A",
        global: "GLOBAL",
      },
      cardLabels: { cert: "Cert", eligible: "Elegíveis", rate: "Taxa", pts: "pontos", partial: "70%+" },
      regionLong: {
        APAC: "Asia-Pacific",
        NA: "North America",
        LATAM: "Latin America",
        EMEA: "Europe",
        "G&A": "General & Administrative",
        GLOBAL: "Áreas Globais",
      },
      regionSection: "POR REGIÃO",
      regionLeader: "líder",
      regionGusSuffix: "GUs",
      eligibleLabel: "elegíveis",
      heroTagline: "Performance por GU nesta temporada",
      crumbLiga: "Liga",
      crumbGus: "GUs",
      heroIn: "em",
      heroRegions: "regiões",
      noResults: "Nenhuma GU encontrada.",
    },
    pessoas: {
      title: "PESSOAS",
      subtitle: "Ranking individual de participantes",
      searchPlaceholder: "Buscar nome ou login...",
      allGroups: "Todas as GUs",
      onlyCertified: "Apenas certificados",
      crumb: { liga: "Liga", pessoas: "Pessoas" },
      hero: {
        title: "Desafiantes",
        people: "pessoas",
        regions: "regiões",
        certified: "certificadas",
      },
      kpi: {
        topScorer: "MAIOR PONTUADOR",
        average: "MÉDIA",
        certified: "CERTIFICADAS",
        points: "pontos",
        trilhasFinished: "trilhas concluídas",
      },
      spotlight: { title: "Top 3", subtitle: "MAIORES PONTUADORES" },
      spotlightLabels: { points: "pontos", trilhas: "Trilhas" },
      trilhas: { title: "TRILHAS", of: "de" },
      trilhaNames: { eng: "Eng GenAI", orch: "Orquestração", soft: "Soft Skills", anthropic: "Anthropic" },
      loadMore: "Carregar mais",
      detail: {
        notFound: "Pessoa não encontrada",
        back: "← Voltar",
        stats: {
          points: "PONTOS",
          rank: "RANK NA GU",
          trilhasDone: "TRILHAS",
          status: "STATUS",
        },
        sections: {
          trilhas: "TRILHAS",
          trilhasSubtitle: "Progresso por trilha",
        },
        trilhaPts: "pts",
        certified: "Certificada",
        anthropicAlreadyCounted:
          "Os pontos da Anthropic já foram contabilizados em outra certificação — não acumulam.",
      },
      stats: {
        total: "Total",
        certified: "Certificados",
        inProgress: "Em progresso",
        notStarted: "Não iniciados",
      },
      podiumTitle: "TOP 3 INDIVIDUAIS",
      tableTitle: "CLASSIFICAÇÃO",
      columns: {
        rank: "#", name: "Nome", gu: "GU", nivel: "Nível",
        eng: "Eng", orch: "Orch", pts: "Pts", status: "Status", trilhas: "Trilhas",
      },
      statuses: {
        certified: "Certificado",
        in_progress: "Em progresso",
        not_started: "Não iniciado",
      },
      pagination: { page: "Pág.", of: "de", prev: "← Ant", next: "Próx →" },
    },
    conquistas: {
      title: "CONQUISTAS",
      subtitle: "Desbloqueie insígnias por marcos na Agentic League",
      crumb: { liga: "Liga", self: "Conquistas" },
      hero: {
        title: "Conquistas",
        medals: "medalhas",
        rarities: "raridades",
        hunters: "caçadores",
      },
      populationPossess: "da Liga possui",
      stats: { total: "Total de conquistas", unlocked: "Desbloqueadas" },
      tabs: { all: "TODAS", comum: "COMUM", rara: "RARA", epica: "ÉPICA", lendaria: "LENDÁRIA" },
      unlockedBy: "desbloqueada por",
      people: "pessoa(s)",
      rarities: { COMUM: "COMUM", RARA: "RARA", ÉPICA: "ÉPICA", LENDÁRIA: "LENDÁRIA" },
      achievements: {
        master_engineering: {
          name: "Gen AI Engineering Master",
          desc: "Concluiu 100% + certificação na trilha Gen AI Engineering Fast Track",
        },
        master_orchestrator: {
          name: "Gen AI Orchestrator Master",
          desc: "Concluiu 100% + certificação na trilha Gen AI Orchestrator",
        },
        master_soft_skills: {
          name: "Gen AI Soft Skills Master",
          desc: "Concluiu 100% + certificação na trilha Gen AI Soft Skills",
        },
        master_anthropic: {
          name: "Anthropic Certified",
          desc: "Conquistou uma certificação oficial Anthropic",
        },
        gu_champion: {
          name: "GU Champion",
          desc: "Pertence a uma das 3 GUs no topo do ranking",
        },
        gu_transformer: {
          name: "GU Transformer",
          desc: "Pertence a uma GU com ≥70% de pessoas certificadas",
        },
        gu_outstanding: {
          name: "GU Outstanding",
          desc: "Pertence a uma GU com ≥90% de pessoas certificadas",
        },
      },
      panel: {
        titlePrefix: "Conquistas de",
        counterLabel: "{n} / {total}",
        sections: {
          personal: "CONQUISTAS",
          guStatus: "STATUS DA SUA GU",
        },
      },
      catalog: {
        title: "Catálogo Geral",
        subtitle: "Todas as conquistas disponíveis na Liga",
      },
      hints: {
        trilhaProgress: "{pct}% da trilha",
        guRank: "Sua GU em {rank}º",
        guPctCertified: "GU: {pct}% certificada",
      },
      strip: {
        header: "CONQUISTAS",
      },
    },
    participants: {
      searchPlaceholder: "Buscar nome ou login...",
      allGroups: "Todos os grupos",
      onlyCertified: "Apenas certificados",
      people: "pessoas",
      columns: {
        name: "Nome", gu: "GU", level: "Nível",
        eng: "Eng %", orch: "Orch %", soft: "Soft %", anthropic: "Anthropic %",
        pts: "Pts", status: "Status",
      },
      statuses: {
        certified: "Certificado",
        in_progress: "Em progresso",
        not_started: "Não iniciado",
      },
      pagination: { page: "Página", of: "de", prev: "← Anterior", next: "Próxima →" },
    },
    admin: {
      title: "Painel Admin",
      accessDenied: "Acesso restrito. Apenas administradores podem acessar esta página.",
      editProgress: {
        title: "Editar progresso individual",
        placeholder: "Login do colaborador...",
        searchBtn: "Buscar",
        notFound: "Colaborador não encontrado.",
        certifiedAt: "Certificado em:",
        save: "Salvar",
        saved: "Salvo!",
      },
      refresh: {
        title: "Atualizar dados",
        button: "Atualizar dados agora",
        loading: "Atualizando...",
        success: "Dados atualizados a partir do Databricks",
        error: "Falha ao atualizar dados",
        hint: "Força a busca de dados frescos do Databricks, ignorando o cache de 24h.",
      },
      danger: {
        title: "Zona de risco",
        reset: "Reset de dados (regera mocks)",
        export: "Exportar estado atual (JSON)",
      },
      prizeEligibility: {
        title: "Elegibilidade ao prêmio (§7.2)",
        hint: "As 3 GUs no topo são finalistas. Cada pessoa certificada de uma GU Top 3 concorre no sorteio com 1 cupom por trilha concluída (as certificações Anthropic contam 1 vez). Cada GU sorteia 3 prêmios do seu valor: $200 (1º), $150 (2º), $100 (3º). Todas as pessoas certificadas concorrem ainda a 4 prêmios de $50. Total: $1.550 USD.",
        positions: {
          1: "1º lugar — 3 prêmios de $200 sorteados entre certificados",
          2: "2º lugar — 3 prêmios de $150 sorteados entre certificados",
          3: "3º lugar — 3 prêmios de $100 sorteados entre certificados",
        },
        empty: "Nenhuma pessoa elegível nesta GU ainda.",
        export: "Exportar CSV",
        exportGeneralPool: "Exportar pool sorteio geral",
        notEnough: "Ranking ainda não tem 3 GUs.",
        columns: {
          rank: "#",
          login: "Login",
          name: "Nome",
          certifiedAt: "Certificado em",
          cupons: "Cupons",
        },
      },
    },
    login: {
      subtitle: "A competição pela transformação agêntica da CI&T",
      loginPrompt: "Faça login para acessar o dashboard",
      signInButton: "Entrar com Google",
      authenticating: "Autenticando...",
      accessNote: "Apenas colaboradores @ciandt.com têm acesso",
    },
    loading: {
      data: "Carregando dados...",
      participants: "Carregando lista de participantes...",
      certifications: "Buscando certificações da University CI&T...",
      reconnecting: "Reconectando sua sessão...",
    },
    loadError: {
      title: "Não foi possível carregar os dados",
      message: "Falha ao buscar a lista de participantes. Tente novamente.",
      retry: "Tentar novamente",
    },
    sessionExpired: {
      title: "Sua sessão expirou",
      message: "Por segurança, sua conexão com o Google expirou. Reconecte para continuar.",
      reconnect: "Reconectar",
    },
    rules: {
      crumb: { liga: "Liga", self: "Regras" },
      hero: {
        title: "Regras",
        subtitle: "Regulamento oficial da Fase Pocket — 03/ago/2026 a 18/set/2026",
      },
      toc: {
        title: "Sumário",
        items: [
          "Objetivos",
          "Comissão Organizadora",
          "Quem pode participar",
          "Como participar",
          "Critérios de avaliação",
          "Critérios de desclassificação",
          "Sistema de Pontuação",
          "Premiação",
          "FAQ",
          "Disposições Gerais",
        ],
      },
      s1: {
        title: "Objetivos",
        intro:
          "A CI&T está investindo na formação de pessoas em IA Agêntica através de trilhas de certificação estruturadas. Para acelerar a adoção de IA Agêntica e transformar nossas GUs em unidades de alta performance, criamos a Agentic League.",
        twoPhases:
          "A \"Fase Pocket\" é uma etapa especial de extensão do Agentic League. O objetivo é manter o engajamento em alta, introduzir os novos conteúdos oficiais da Anthropic e acelerar a adoção de IA por meio do aprendizado contínuo.",
        phase1Label: "Fase Pocket (03/ago – 18/set/2026)",
        phase1Desc:
          "Manter o engajamento em alta, introduzir os novos conteúdos oficiais da Anthropic e acelerar a adoção de IA por toda a empresa por meio do aprendizado contínuo.",
        scope:
          "O presente regulamento refere-se exclusivamente à Fase Pocket do programa.",
      },
      s2: {
        title: "Comissão Organizadora",
        members: [
          "Giovana Marconi",
          "Elen Reco de Oliveira",
          "Mateus Bahia",
          "Marília Varoni",
          "Rafael Franco Freitas",
          "Ana Paula Araujo Caixeta",
          "Rafael Bento Da Silva Soares",
          "Rodrigo Padula de Oliveira",
          "Davi Gonçalves Peterlini",
          "Vitoria Cavalaro Nogueira",
          "Maira Carvalho",
        ],
      },
      s3: {
        title: "Quem pode participar",
        eligibleTitle: "2.1 Público Elegível",
        eligible: "Todas as pessoas da CI&T podem participar desta jornada de certificação.",
        notEligibleTitle: "Não podem participar:",
        notEligible: [
          "Membros da comissão organizadora do Agentic League",
          "Estagiários e terceiros",
        ],
        requirementsTitle: "2.2 Requisitos Obrigatórios",
        requirements: [
          "Ter vínculo empregatício ativo com a CI&T durante todo o período da Fase Pocket",
          "Estar alocada em uma GU/Área",
        ],
        registrationTitle: "2.3 Participação Automática",
        registration:
          "Todas as pessoas elegíveis já estão pré-qualificadas e com o acesso liberado à plataforma. Não há necessidade de se inscrever — basta acessar as trilhas e começar quando quiser. A participação é totalmente voluntária; apenas os profissionais ativos na plataforma acumularão pontos na contagem final. Para valorizar o esforço e o aprendizado contínuo, todas as certificações válidas já estão sendo contabilizadas para o placar desta fase, independentemente da data em que foram obtidas.",
      },
      s4: {
        title: "Como participar",
        periodTitle: "3. Período de Participação",
        period: "Início: 3 de agosto de 2026. Encerramento: 18 de setembro de 2026, às 18:00 (BRT).",
        deadline: "Data limite para certificações: 18 de setembro de 2026, às 18:00 (BRT).",
        tracksTitle: "4. As Trilhas e o Sistema de Pontuação",
        tracksIntro:
          "Temos um total de 6 trilhas/certificações disponíveis e todas as pessoas podem realizá-las:",
        tracks: [
          {
            name: "Gen AI Engineering Fast Track",
            hours: "LinkedIn Learning",
            url: "https://www.linkedin.com/learning/paths/ci-t-gen-ai-engineering-fast-track",
            scoring: "70% = 250 pts · 100% + Certificação = 500 pts",
          },
          {
            name: "Gen AI Orchestrator",
            hours: "LinkedIn Learning",
            url: "https://www.linkedin.com/learning/paths/ci-t-gen-ai-orchestrator-certification-pathway",
            scoring: "70% = 250 pts · 100% + Certificação = 500 pts",
          },
          {
            name: "Gen AI Soft Skills",
            hours: "LinkedIn Learning",
            url: "https://www.linkedin.com/learning/paths/ci-t-soft-skills-certification-pathway?u=451056106",
            scoring: "70% = 250 pts · 100% + Certificação = 500 pts",
          },
          {
            name: "Anthropic: Developer Foundations",
            hours: "Skilljar (Anthropic)",
            url: "https://anthropic-partners.skilljar.com/claude-certified-developer-foundations-certification",
            scoring: "Certificação = 1.000 pts",
          },
          {
            name: "Anthropic: Architect Foundations",
            hours: "Skilljar (Anthropic)",
            url: "https://anthropic-partners.skilljar.com/claude-certified-architect-foundations-certification",
            scoring: "Certificação = 1.000 pts",
          },
          {
            name: "Anthropic: Architect Professional",
            hours: "Skilljar (Anthropic)",
            url: "https://anthropic-partners.skilljar.com/claude-certified-architect-professional-certification",
            scoring: "Certificação = 1.000 pts",
          },
        ],
        emailRuleTitle: "5. Regras",
        emailRule:
          "Use o email @ciandt.com durante toda sua jornada de certificação nas plataformas do LinkedIn Learning, da University e na plataforma de cursos da Anthropic (Skilljar). Cada inscrição com domínio CI&T reforça nossa presença como parceiro estratégico da Anthropic e conta para nossas métricas de adoção. Para que a sua trilha seja considerada 100% completa no game, a obtenção do seu certificado precisa obrigatoriamente estar registrada na plataforma University.",
        emailRuleLinkLabel: "Como vincular sua conta no LinkedIn Learning",
        emailRuleLinkUrl:
          "https://docs.google.com/presentation/d/1C6FTlfirU2pyCAoD08alcddgC32_Dj4rOpwMwKH1HVc/edit",
        supportTitle: "Acesso e Suporte",
        support:
          "Dúvidas sobre o programa podem ser esclarecidas:",
        supportChannelLabel: "Canal:",
        supportChannel:
          "Não temos um canal oficial para a fase pocket do Agentic League. Por isso, caso surja alguma dúvida, busque os comunicados realizados no grupo",
        supportChannelLinkLabel: "[Official CI&Ters] Internal Comms",
        supportChannelLinkUrl: "https://chat.google.com/room/AAAAMjpnSKc?cls=7",
        supportChannelSuffix:
          "e utilize a thread para enviar a sua dúvida. Ou procure por uma das pessoas da comissão organizadora para suporte.",
        supportFaqLabel: "FAQ:",
        supportFaqSuffix: "Acesse o FAQ presente neste documento.",
        supportFaqLinkLabel: "📢 AGENTIC LEAGUE: POCKET - OFFICIAL RULES + FAQ",
        supportFaqLinkUrl:
          "https://docs.google.com/document/d/1UAI8AdFeky0vzRXVusP1Xqd7Fr5-KWgD7qlXJWd7quI",
      },
      s5: {
        title: "Critérios de avaliação",
        validationTitle: "5.1 Validação de Conclusão",
        validation: [
          "A trilha deve ser completada até 18/setembro/2026 às 18:00 BRT.",
          "O progresso deve estar visível na plataforma University (Talent — https://university.ciandt.com/).",
          "As trilhas só são consideradas completas quando os certificados são gerados pela plataforma University (Talent) — para cursos hospedados nela — ou enviados a ela, no caso de conteúdos externos, usando os links indicados nas trilhas do LinkedIn Learning.",
          "A certificação deve ser emitida oficialmente.",
          "O email usado deve ser @ciandt.com.",
        ],
        exampleCaption: "Exemplo de link para envio de certificados externos",
        exampleCaptionQuiz: "Exemplo de link para quiz na plataforma University (Talent)",
        multiTitle: "5.2 Múltiplas Trilhas",
        multi:
          "Cada pessoa pode completar quantas trilhas quiser. Todos os pontos acumulam para a GU.",
        progressTitle: "5.3 Atualização de Progresso",
        progress:
          "O progresso é atualizado a cada 2 dias e pode ser acompanhado no dashboard oficial da Liga.",
        responsibilitiesTitle: "6. Responsabilidade",
        responsibilities: [
          "Da pessoa participante: Completar trilhas, garantir que o email @ciandt.com esteja conectado e acompanhar seu progresso no dashboard.",
          "Da CI&T: Disponibilizar plataforma de acompanhamento de progresso, atualizar ranking semanalmente, fornecer suporte técnico.",
          "A CI&T não se responsabiliza por: Problemas individuais de acesso, conexão de internet, perda de progresso não salvo na plataforma.",
        ],
      },
      s6: {
        title: "Critérios para desclassificação",
        intro: "Serão desqualificadas as pessoas participantes que:",
        items: [
          "Utilizarem email diferente de @ciandt.com nas inscrições do LinkedIn Learning — uma vez que isso impossibilita nosso acompanhamento de progresso.",
          "Cometerem fraude comprovada (cópia de certificados, manipulação de dados, etc).",
          "Violarem o Código de Ética da CI&T.",
          "Tiverem vínculo empregatício encerrado antes do pagamento dos prêmios.",
        ],
      },
      s7: {
        title: "Sistema de Pontuação",
        individualTitle: "8.1 Pontuação Individual",
        individual: "Cada pessoa acumula pontos baseado no progresso nas trilhas:",
        table: {
          headers: { track: "Trilha", at70: "70% completo", at100: "100% + Certificação" },
          rows: [
            { track: "Engineering Fast Track", at70: "250 pts", at100: "500 pts" },
            { track: "Orchestrator Track", at70: "250 pts", at100: "500 pts" },
            { track: "Soft Skills Track", at70: "250 pts", at100: "500 pts" },
            { track: "Anthropic: Developer Foundations", at70: "—", at100: "1.000 pts" },
            { track: "Anthropic: Architect Foundations", at70: "—", at100: "1.000 pts" },
            { track: "Anthropic: Architect Professional", at70: "—", at100: "1.000 pts" },
          ],
        },
        notesTitle: "Observações",
        notes: [
          "As certificações da Anthropic contabilizam pontos uma única vez. Ou seja, se você concluir uma, duas ou as três certificações da Anthropic, você garantirá os 1.000 pontos na sua pontuação final apenas uma vez.",
          "Os pontos são cumulativos (exceto em certificações Anthropic), então você pode realizar múltiplas trilhas.",
          "Dentro da mesma trilha, 70% e 100% não se somam — vale a maior conclusão.",
        ],
        exampleTitle: "Exemplo de pontuação individual",
        exampleLines: [
          "Solange completou:",
          "Engineering 100% + certificação = 500 pts",
          "Soft Skills 70% = 250 pts",
          "Anthropic: Architect Foundations = 1.000 pts (conta uma vez)",
          "Anthropic: Architect Professional = já contabilizado acima",
        ],
        exampleTotal: "Total de Solange: 1.750 pts",
        guTitle: "9.2 Pontuação da GU",
        guIntro:
          "Para garantir equidade entre GUs menores e maiores, a pontuação final utiliza uma fórmula com fator logarítmico baseado no tamanho da equipe. Isso permite que GUs com poucas pessoas, mas alta taxa de certificação, possam competir com GUs grandes. Em contrapartida, o logaritmo recompensa o volume absoluto da GU, freando a vantagem irreal das GUs menores.",
        formulaLabel: "Fórmula:",
        formula: "Pontos GU = [ (Pontos Individuais / Elegíveis) × 100 ] × log10(Elegíveis)",
        guExampleTitle: "Exemplo prático (GU Alpha vs GU Beta)",
        guExample: [
          "GU Alpha (50 membros): 25 pessoas × 1.500 pts = 37.500 pts → (37.500/50)×100 × log10(50) ≈ 127.500 Pontos Finais.",
          "GU Beta (5 membros): 4 pessoas × 2.500 pts = 10.000 pts → (10.000/5)×100 × log10(5) ≈ 140.000 Pontos Finais.",
          "Resultado: GU Beta (5 pessoas) levou o 1º lugar, pois os membros gabaritaram o jogo; GU Alpha garantiu o 2º lugar com a fórmula recompensando o volume de 25 pessoas mobilizadas.",
        ],
        tiebreakTitle: "Critérios de Desempate",
        tiebreakIntro:
          "Se duas GUs tiverem a mesma pontuação final, os critérios serão aplicados nesta ordem:",
        tiebreak: [
          "GU com mais pessoas certificadas (100% em pelo menos 1 trilha).",
          "Ordem cronológica (primeira GU a atingir a pontuação).",
        ],
        decimals: "As pontuações usarão 2 casas decimais.",
      },
      s8: {
        title: "Premiação",
        intro: "A premiação da Fase Pocket do Agentic League é dividida em 2 níveis:",
        level1Title: "9.1 Nível 1 — Badges de Reconhecimento",
        level1Intro:
          "Todas as pessoas ganham badges digitais conforme as conclusões das trilhas.",
        badgesIndividualTitle: "Badges de Especialização",
        badgesIndividual: [
          {
            emoji: "💻",
            name: "Gen AI Engineering Master",
            req: "100% + Certificação Engineering Fast Track",
            desc: "Dominou a trilha Engineering Fast Track de IA Agêntica.",
          },
          {
            emoji: "🎼",
            name: "Gen AI Orchestrator Master",
            req: "100% + Certificação Orchestrator Track",
            desc: "Dominou a trilha Orchestrator de IA Agêntica.",
          },
          {
            emoji: "🧠",
            name: "Gen AI Soft Skills Master",
            req: "100% + Certificação Soft Skills Track",
            desc: "Dominou habilidades essenciais para a era agêntica.",
          },
          {
            emoji: "🐙",
            name: "Anthropic Certified",
            req: "Certificação Anthropic",
            desc: "Certificado oficial Anthropic em CCA-F, CCDV-F, CCAR-F e/ou CCAR-P.",
          },
        ],
        badgesGuTitle: "Badges Colaborativos (GU)",
        badgesGu: [
          {
            emoji: "🏆",
            name: "GU Champion",
            req: "Sua GU ficou Top 3",
            desc: "Membro de GU vencedora da Agentic League Fase Pocket.",
          },
          {
            emoji: "🎯",
            name: "GU Transformer",
            req: "Sua GU atingiu 70%+ de certificação",
            desc: "Membro de GU que transformou 70%+ do time.",
          },
          {
            emoji: "💪",
            name: "GU Outstanding",
            req: "Sua GU atingiu 90%+ de certificação",
            desc: "Membro de GU com 90% ou mais de certificação.",
          },
        ],
        level2Title: "9.2 Nível 2 — Prêmios Financeiros (Top 3 GUs)",
        level2Intro:
          "O placar considerará as 3 GUs com a maior pontuação (utilizando a fórmula normalizada) como as grandes finalistas da Fase Pocket. As pessoas que obtiverem pelo menos 1 certificação e que pertencem às Top 3 GUs concorrerão aos prêmios em dinheiro por meio de sorteio (três prêmios por GU). Além disso, todas as pessoas certificadas — de qualquer GU — concorrem a 4 prêmios de $50 USD. Cada certificação 100% concluída equivale a 1 cupom (chance) no sorteio — quanto mais trilhas, mais chances de ganhar.",
        prizes: [
          {
            place: "🥇 1ª GU",
            top: "Sorteio entre certificados",
            per: "$200 USD por sorteio",
            total: "3 prêmios de $200 USD",
          },
          {
            place: "🥈 2ª GU",
            top: "Sorteio entre certificados",
            per: "$150 USD por sorteio",
            total: "3 prêmios de $150 USD",
          },
          {
            place: "🥉 3ª GU",
            top: "Sorteio entre certificados",
            per: "$100 USD por sorteio",
            total: "3 prêmios de $100 USD",
          },
          {
            place: "🎁 Consolação",
            top: "Todas as pessoas certificadas",
            per: "$50 USD por sorteio",
            total: "4 prêmios de $50 USD",
          },
        ],
        prizesTotal: "Total de prêmios financeiros: $1.550 USD",
        rulesTitle: "Regras do Sorteio",
        rules: [
          "Cada certificação 100% concluída equivale a 1 cupom (chance) no sorteio da sua GU.",
          "As certificações da Anthropic contam 1 vez no sorteio (independentemente de quantas você fizer).",
          "Qualquer trilha concluída habilita participação no sorteio — não há restrição por tipo de trilha.",
          "A pessoa vencedora deverá ter vínculo empregatício ativo com a CI&T no momento do pagamento.",
        ],
        paymentTitle: "Anúncio e Pagamento",
        payment: [
          "Anúncio dos vencedores: 21/setembro/2026.",
          "Forma de pagamento: conforme regras legais de cada país.",
          "Prazo de pagamento: até 21/outubro/2026.",
          "Conversão para moeda local: taxa de câmbio do dia do pagamento.",
        ],
      },
      faq: {
        title: "FAQ",
        intro:
          "Dúvidas frequentes sobre a Fase Pocket do Agentic League.",
        linkLabel: "Acessar o FAQ da Agentic League",
        linkUrl:
          "https://docs.google.com/document/d/1UAI8AdFeky0vzRXVusP1Xqd7Fr5-KWgD7qlXJWd7quI",
        items: [
          {
            q: "O que é Agentic League?",
            a: "A CI&T está investindo na formação de pessoas em IA Agêntica através de trilhas de certificação estruturadas. Para acelerar a adoção de IA Agêntica e transformar nossas GUs em unidades de alta performance, criamos o Agentic League, um gamification que incentiva o treinamento e formação das pessoas nas trilhas agênticas, através de um sistema de pontuação e premiação.",
          },
          {
            q: "O que é a Fase Pocket?",
            a: "A \"Fase Pocket\" é uma etapa especial e intermediária de extensão do Agentic League. O objetivo é manter o engajamento em alta, introduzir os novos conteúdos oficiais da Anthropic e acelerar a adoção de IA por toda a empresa por meio do aprendizado contínuo.",
          },
          {
            q: "Quanto tempo dura a Fase Pocket?",
            a: "Esta etapa acontece de 3 de agosto de 2026 a 18 de setembro de 2026, às 18:00 (BRT).",
          },
          {
            q: "É obrigatório participar?",
            a: "Não é obrigatório. A participação é totalmente voluntária, e caso você opte por não participar, nenhuma ação é necessária — apenas os profissionais ativos na plataforma acumularão pontos.",
          },
          {
            q: "Existem outras fases do game?",
            a: "Sim. A Agentic League contou com a fase 1, que aconteceu durante junho e julho e foi destinada apenas para pessoas P5 e P6.",
          },
          {
            q: "Quem pode participar?",
            a: "Todas as pessoas da CI&T podem participar, com exceção de: membros da comissão organizadora, estagiários e terceiros.",
          },
          {
            q: "Preciso me inscrever?",
            a: "Não. Todas as pessoas elegíveis já estão pré-qualificadas automaticamente e com o acesso liberado à plataforma.",
          },
          {
            q: "Quais trilhas estão disponíveis?",
            a: "Temos 6 trilhas/certificações nesta fase: Gen AI Engineering Fast Track (500 pts com 100%), Gen AI Orchestrator (500 pts com 100%), Gen AI Soft Skills (500 pts com 100%), Anthropic - Developer Foundations (1.000 pts), Anthropic - Architect Foundations (1.000 pts) e Anthropic - Architect Professional (1.000 pts). Cada pessoa pode completar quantas trilhas quiser. Todos os pontos acumulam para a GU, com exceção das certificações Anthropic, que pontuam uma única vez.",
          },
          {
            q: "Posso fazer mais de uma trilha?",
            a: "Sim! Pontos acumulam. Quanto mais trilhas, mais pontos para sua GU.",
          },
          {
            q: "Posso fazer mais de uma certificação da Anthropic? Elas se somam na pontuação?",
            a: "Você pode fazer todas as certificações que desejar, mas para a pontuação da GU, as certificações da Anthropic contabilizam 1.000 pontos uma única vez. O teto máximo de pontuação que uma pessoa pode gerar para a GU é de 2.500 pontos.",
          },
          {
            q: "Sou de Tech, posso fazer a trilha de Orchestrator?",
            a: "SIM! Todo mundo pode fazer todas as trilhas. Não há restrição.",
          },
          {
            q: "Sou de Gestão, posso fazer a trilha de Engineering?",
            a: "SIM! Todo mundo pode fazer todas as trilhas. Não há restrição.",
          },
          {
            q: "Quanto tempo tenho para completar as trilhas?",
            a: "Até 18 de setembro de 2026, às 18:00 (BRT).",
          },
          {
            q: "O que acontece se eu completar 70% da trilha?",
            a: "Você ganha 250 pontos para sua GU (exceto Anthropic, que só pontua com 100% da trilha concluída), mas não ganha prêmio financeiro (só badges e reconhecimento simbólico).",
          },
          {
            q: "Qual trilha vale mais pontos?",
            a: "As 3 trilhas da Anthropic valem 1.000 pontos cada, mas contabilizam apenas uma vez na pontuação total da pessoa. A pontuação máxima por pessoa é de 2.500 pontos.",
          },
          {
            q: "Posso começar uma trilha e mudar para outra?",
            a: "Sim! Você pode fazer as trilhas na ordem que quiser. O progresso será capturado de acordo com a submissão na University.",
          },
          {
            q: "Como sei que minha certificação foi validada?",
            a: "Você pode consultar nosso dashboard para acompanhar se sua certificação foi validada. A atualização pode levar de 1 a 2 dias. Para que a sua trilha seja considerada 100% completa, a obtenção do certificado precisa estar registrada na plataforma University.",
          },
          {
            q: "Como funciona o histórico de certificados já tirados?",
            a: "Para valorizar o aprendizado contínuo, todas as certificações válidas já estão sendo contabilizadas para o placar desta Fase Pocket, independentemente da data em que foram obtidas.",
          },
          {
            q: "Por que preciso usar email @ciandt.com?",
            a: "Porque cada inscrição com @ciandt.com reforça nossa presença como parceiro Anthropic, conta para métricas de adoção, é rastreável pelo sistema e é requisito oficial do programa.",
          },
          {
            q: "Já comecei com email pessoal, e agora?",
            a: "Migre antes de avançar. Entre em contato com suporte no canal Google Chat para orientação sobre como migrar sua conta.",
          },
          {
            q: "Como vincular minha conta do LinkedIn Learning?",
            a: "Siga o guia oficial: [How to] LinkedIn Learning. Se tiver dúvidas, pergunte no canal de suporte.",
          },
          {
            q: "Não consigo acessar o LinkedIn Learning, o que fazer?",
            a: "Verifique se sua conta CI&T está ativa, tente acessar com @ciandt.com, limpe o cache do navegador e, se persistir, reporte no canal de suporte.",
          },
          {
            q: "Preciso usar @ciandt.com na plataforma Anthropic também?",
            a: "SIM! Use @ciandt.com em todas as inscrições: LinkedIn Learning, University e Skilljar (plataforma de cursos da Anthropic).",
          },
          {
            q: "Como funciona a premiação em dinheiro nesta fase?",
            a: "Nesta fase, a premiação foca no engajamento coletivo. O placar considerará as 3 GUs com a maior pontuação como finalistas. Os prêmios em dinheiro serão sorteados entre as pessoas que obtiverem pelo menos 1 certificação dentro dessas GUs vencedoras. Também faremos um sorteio mais amplo, entre todas as pessoas certificadas em pelo menos uma das trilhas, valendo 4 prêmios no valor de $50 USD cada. Para todos os sorteios, as suas chances são proporcionais ao seu esforço: cada certificação 100% concluída equivale a 1 \"cupom\" no sorteio. Se você concluiu 4 certificações, seu nome entrará 4 vezes na urna da sua GU, multiplicando suas chances de ganhar o prêmio! Com exceção de certificações Anthropic, que serão contabilizadas uma única vez.",
          },
          {
            q: "Quais são os valores dos prêmios financeiros?",
            a: "Cada GU Top 3 sorteia três prêmios do seu valor: 1º Lugar (GU) — 3 prêmios de $200 USD; 2º Lugar (GU) — 3 prêmios de $150 USD; 3º Lugar (GU) — 3 prêmios de $100 USD. Além disso, todas as pessoas certificadas (de qualquer GU) concorrem a 4 prêmios de $50 USD. Total: $1.550 USD.",
          },
          {
            q: "E as Badges de reconhecimento?",
            a: "Todas as pessoas ganham badges digitais (Engineering Master, Orchestrator Master, Soft Skills Master e Anthropic Certified) sempre que atingirem 100% dos requisitos de uma trilha.",
          },
          {
            q: "Quando mudo de GU, meus pontos vão comigo?",
            a: "Sim, os pontos são individuais e irão para nova GU com você.",
          },
          {
            q: "Como o sorteio recompensa quem se certificou em mais trilhas?",
            a: "(A Regra de Ouro) As suas chances no sorteio são proporcionais ao seu esforço. Cada certificação 100% concluída equivale a 1 \"cupom\" no sorteio. Se você concluiu 4 certificações, seu nome entrará 4 vezes na urna da sua GU, multiplicando suas chances de ganhar o prêmio! Com exceção de certificações Anthropic, que serão contabilizadas uma única vez.",
          },
          {
            q: "Como funciona a pontuação da GU?",
            a: "Para garantir uma competição justa, a pontuação final da GU utiliza uma fórmula com fator logarítmico: [ (Total de Pontos Individuais / Total de Pessoas Elegíveis) × 100 ] × log10(Total de Pessoas Elegíveis).",
          },
          {
            q: "Como vejo o ranking?",
            a: "Acesse o dashboard do Agentic League para ver o Top 10 GUs, seu progresso individual e o percentual da sua GU.",
          },
          {
            q: "Quando o ranking é atualizado?",
            a: "Pode levar de 1 a 2 dias para ser atualizado.",
          },
          {
            q: "Por que meu progresso não aparece no dashboard?",
            a: "Possíveis motivos: você usou email diferente de @ciandt.com; o sistema ainda não sincronizou (aguarde até 2 dias); você não completou todas as etapas de submissão do certificado na University; ou houve um problema técnico (reporte no canal de suporte).",
          },
          {
            q: "Posso ver o progresso de outras pessoas?",
            a: "Sim, no dashboard você vê o nome de todos os participantes da sua GU, o percentual de progresso de cada um e os pontos acumulados.",
          },
          {
            q: "O que acontece em caso de empate?",
            a: "Critérios de desempate (nesta ordem): 1) GU com mais pessoas certificadas (100%); 2) Ordem cronológica (primeira a atingir a pontuação).",
          },
          {
            q: "Quem ganha badges?",
            a: "TODO MUNDO que completar 100% de pelo menos 1 trilha. Badges são para reconhecimento, não são prêmios financeiros.",
          },
          {
            q: "Quantos badges posso ganhar?",
            a: "Depende! Se você completar 4 trilhas = 4 badges de especialização. Se sua GU ficar Top 3 = +1 badge GU Champion. Máximo de 7 badges se preencher todos os critérios.",
          },
          {
            q: "Posso colocar os badges no LinkedIn?",
            a: "SIM! Incentivamos que você adicione ao seu perfil. Reforça sua expertise e a parceria CI&T × Anthropic.",
          },
          {
            q: "Badges têm validade?",
            a: "Não! Badges são permanentes. Você pode usar para sempre.",
          },
          {
            q: "Quem ganha prêmio em dinheiro?",
            a: "A partir das Top 3 GUs com maior pontuação, iremos sortear as pessoas certificadas dentro de cada uma das GUs. Pessoas com mais certificações têm mais chances de ganhar (a cada 1 certificação = 1 chance de ganhar). Além disso, todas as pessoas certificadas concorrerão também a 4 prêmios no valor de $50 USD cada.",
          },
          {
            q: "Quando recebo o prêmio?",
            a: "Anúncio dos vencedores: 21/09/2026. Prazo de pagamento: até 21/10/2026. Conversão para moeda local: taxa de câmbio do dia do pagamento.",
          },
          {
            q: "Como recebo o prêmio?",
            a: "A premiação poderá ser realizada através de vouchers ou folha de pagamento, de acordo com as regras de cada país.",
          },
        ],
        whereToAskLabel: "Onde tiro dúvidas?",
      },
      s9: {
        title: "Disposições Gerais",
        acceptanceTitle: "11.1 Aceitação dos Termos",
        acceptance:
          "Ao participar automaticamente do programa, a pessoa declara estar ciente e de acordo com todos os termos deste regulamento.",
        phase2Title: "11.2 Modificações no Regulamento",
        phase2:
          "O comitê organizador se reserva o direito de ajustar datas em caso de força maior (com 7 dias de antecedência), modificar critérios técnicos com comunicação prévia e cancelar o programa por motivos excepcionais (com notificação formal). Qualquer modificação será comunicada via email e no canal do Google Chat.",
        modificationsTitle: "11.3 Casos Omissos",
        modifications: [
          "Toda e qualquer situação não prevista neste Regulamento será decidida exclusivamente pela comissão organizadora.",
          "As decisões da comissão organizadora são finais e irrecorríveis.",
        ],
        modificationsNote:
          "Qualquer modificação será comunicada via email e no canal do Google Chat.",
        omissionsTitle: "11.4 Código de Ética",
        omissions:
          "A CI&T não tolerará nenhum tipo de ação que vise burlar e/ou fraudar as regras do programa. Violações ao Código de Ética da CI&T resultarão em desclassificação imediata, reporte formal ao RH e possíveis medidas disciplinares conforme políticas internas. Importante: os participantes não devem inserir nem enviar dados reais, código proprietário da CI&T, dados confidenciais de clientes ou propriedade intelectual interna em plataformas de aprendizado de IA de terceiros ou em exercícios de certificação.",
        ethicsTitle: "11.5 Elegibilidade para Premiação",
        ethics:
          "Para estar apto a receber prêmios financeiros, a pessoa vencedora deverá ter vínculo empregatício ativo com a CI&T em 21/10/2026 (data de pagamento), não estar em processo de desligamento e não ter sido desclassificada por nenhum critério deste regulamento.",
        eligibilityTitle: "11.6 Dúvidas",
      },
    },
  },
  en: {
    nav: {
      liga: "League",
      gus: "GUs",
      pessoas: "People",
      conquistas: "Achievements",
      rules: "Rules",
      admin: "Admin",
      dashboard: "Dashboard",
      ranking: "Ranking",
      participants: "Participants",
    },
    header: {
      signOut: "Sign out",
      openMenu: "Open menu",
      closeMenu: "Close menu",
      toggleTheme: "Toggle theme",
      phases: {
        pre: "PRE-LAUNCH",
        active: "SEASON IN PROGRESS",
        encerrado: "CLOSED",
      },
    },
    liga: {
      seasonBadge: "SEASON IN PROGRESS",
      title: "AGENTIC LEAGUE.",
      subtitle: "The competition for agentic transformation at CI&T",
      heroParticipants: "participants",
      heroGus: "GUs",
      heroIn: "in",
      heroRegions: "regions",
      statActive: "active",
      statRegions: "regions",
      statRate: "rate",
      eligibleLabel: "eligible",
      pointsLabel: "points",
      certShort: "cert",
      countdownTitle: "League ends in",
      expired: "League closed — waiting for official ranking",
      pre: "League starts {date}",
      countdown: { days: "days", hours: "hrs", minutes: "min", seconds: "sec" },
      metrics: {
        participants: "Participants",
        activeGUs: "Active GUs",
        certified: "Certified People",
        totalCertifications: "Total Certifications",
      },
      podiumTitle: "TOP 3 GUS",
      podiumSubtitle: "Points race",
      evolutionTitle: "CERTIFICATION EVOLUTION",
      evolutionSubtitle: "Last 60 days",
      evolutionEmpty: "No certifications in the last 60 days.",
      evolutionSeries: { people: "Certified People", certifications: "Total Certifications" },
      rankingTitle: "FULL RANKING",
      top10Title: "TOP 10",
      viewAll: "View all",
      leaderChip: "Absolute leader",
      estPrize: "Est. prize",
      columns: {
        pos: "Pos", gu: "GU", eligible: "Eligible",
        cert: "Cert.", pct: "% Cert.", pts: "GU Pts", prize: "Prize",
      },
      pagination: { page: "Pg.", of: "of", prev: "← Prev", next: "Next →" },
    },
    gus: {
      title: "GROWTH UNITS",
      subtitle: "GU performance this season",
      searchPlaceholder: "Search GU…",
      sortLabel: "Sort by",
      sortOptions: {
        pts: "Points",
        cert: "Certified",
        pct: "% Rate",
        name: "Name",
      },
      tabs: {
        all: "ALL",
        apac: "APAC",
        na: "NA",
        latam: "LATAM",
        emea: "EMEA",
        ga: "G&A",
        global: "GLOBAL",
      },
      cardLabels: { cert: "Cert", eligible: "Eligible", rate: "Rate", pts: "points", partial: "70%+" },
      regionLong: {
        APAC: "Asia-Pacific",
        NA: "North America",
        LATAM: "Latin America",
        EMEA: "Europe",
        "G&A": "General & Administrative",
        GLOBAL: "Global Areas",
      },
      regionSection: "BY REGION",
      regionLeader: "leader",
      regionGusSuffix: "GUs",
      eligibleLabel: "eligible",
      heroTagline: "GU performance this season",
      crumbLiga: "League",
      crumbGus: "GUs",
      heroIn: "in",
      heroRegions: "regions",
      noResults: "No GUs found.",
    },
    pessoas: {
      title: "PEOPLE",
      subtitle: "Individual participant ranking",
      searchPlaceholder: "Search name or login...",
      allGroups: "All GUs",
      onlyCertified: "Certified only",
      crumb: { liga: "League", pessoas: "People" },
      hero: {
        title: "Challengers",
        people: "people",
        regions: "regions",
        certified: "certified",
      },
      kpi: {
        topScorer: "TOP SCORER",
        average: "AVERAGE",
        certified: "CERTIFIED",
        points: "points",
        trilhasFinished: "trails finished",
      },
      spotlight: { title: "Top 3", subtitle: "TOP SCORERS" },
      spotlightLabels: { points: "points", trilhas: "Trails" },
      trilhas: { title: "TRAILS", of: "of" },
      trilhaNames: { eng: "Eng GenAI", orch: "Orchestration", soft: "Soft Skills", anthropic: "Anthropic" },
      loadMore: "Load more",
      detail: {
        notFound: "Person not found",
        back: "← Back",
        stats: {
          points: "POINTS",
          rank: "GU RANK",
          trilhasDone: "TRAILS",
          status: "STATUS",
        },
        sections: {
          trilhas: "TRAILS",
          trilhasSubtitle: "Progress per trail",
        },
        trilhaPts: "pts",
        certified: "Certified",
        anthropicAlreadyCounted:
          "Anthropic points were already counted from another certification — they don't stack.",
      },
      stats: {
        total: "Total",
        certified: "Certified",
        inProgress: "In progress",
        notStarted: "Not started",
      },
      podiumTitle: "TOP 3 INDIVIDUALS",
      tableTitle: "RANKING",
      columns: {
        rank: "#", name: "Name", gu: "GU", nivel: "Level",
        eng: "Eng", orch: "Orch", pts: "Pts", status: "Status", trilhas: "Trails",
      },
      statuses: {
        certified: "Certified",
        in_progress: "In progress",
        not_started: "Not started",
      },
      pagination: { page: "Pg.", of: "of", prev: "← Prev", next: "Next →" },
    },
    conquistas: {
      title: "ACHIEVEMENTS",
      subtitle: "Unlock badges for milestones in the Agentic League",
      crumb: { liga: "League", self: "Achievements" },
      hero: {
        title: "Achievements",
        medals: "medals",
        rarities: "rarities",
        hunters: "hunters",
      },
      populationPossess: "of the League has it",
      stats: { total: "Total achievements", unlocked: "Unlocked" },
      tabs: { all: "ALL", comum: "COMMON", rara: "RARE", epica: "EPIC", lendaria: "LEGENDARY" },
      unlockedBy: "unlocked by",
      people: "person(s)",
      rarities: { COMUM: "COMMON", RARA: "RARE", ÉPICA: "EPIC", LENDÁRIA: "LEGENDARY" },
      achievements: {
        master_engineering: {
          name: "Gen AI Engineering Master",
          desc: "Completed 100% + certification on the Gen AI Engineering Fast Track",
        },
        master_orchestrator: {
          name: "Gen AI Orchestrator Master",
          desc: "Completed 100% + certification on the Gen AI Orchestrator track",
        },
        master_soft_skills: {
          name: "Gen AI Soft Skills Master",
          desc: "Completed 100% + certification on the Gen AI Soft Skills track",
        },
        master_anthropic: {
          name: "Anthropic Certified",
          desc: "Earned an official Anthropic certification",
        },
        gu_champion: {
          name: "GU Champion",
          desc: "Belongs to one of the top 3 GUs in the ranking",
        },
        gu_transformer: {
          name: "GU Transformer",
          desc: "Belongs to a GU with ≥70% of people certified",
        },
        gu_outstanding: {
          name: "GU Outstanding",
          desc: "Belongs to a GU with ≥90% of people certified",
        },
      },
      panel: {
        titlePrefix: "Achievements of",
        counterLabel: "{n} / {total}",
        sections: {
          personal: "ACHIEVEMENTS",
          guStatus: "YOUR GU STATUS",
        },
      },
      catalog: {
        title: "General Catalog",
        subtitle: "All achievements available in the League",
      },
      hints: {
        trilhaProgress: "{pct}% of the track",
        guRank: "Your GU at #{rank}",
        guPctCertified: "GU: {pct}% certified",
      },
      strip: {
        header: "ACHIEVEMENTS",
      },
    },
    participants: {
      searchPlaceholder: "Search name or login...",
      allGroups: "All groups",
      onlyCertified: "Certified only",
      people: "people",
      columns: {
        name: "Name", gu: "GU", level: "Level",
        eng: "Eng %", orch: "Orch %", soft: "Soft %", anthropic: "Anthropic %",
        pts: "Pts", status: "Status",
      },
      statuses: {
        certified: "Certified",
        in_progress: "In progress",
        not_started: "Not started",
      },
      pagination: { page: "Page", of: "of", prev: "← Previous", next: "Next →" },
    },
    admin: {
      title: "Admin Panel",
      accessDenied: "Access restricted. Only administrators can access this page.",
      editProgress: {
        title: "Edit individual progress",
        placeholder: "Collaborator login...",
        searchBtn: "Search",
        notFound: "Collaborator not found.",
        certifiedAt: "Certified at:",
        save: "Save",
        saved: "Saved!",
      },
      refresh: {
        title: "Refresh data",
        button: "Refresh data now",
        loading: "Refreshing...",
        success: "Data refreshed from Databricks",
        error: "Failed to refresh data",
        hint: "Forces a fresh fetch from Databricks, bypassing the 24h cache.",
      },
      danger: {
        title: "Danger zone",
        reset: "Reset data (regenerate mocks)",
        export: "Export current state (JSON)",
      },
      prizeEligibility: {
        title: "Prize eligibility (§7.2)",
        hint: "The top 3 GUs are finalists. Each certified person in a Top-3 GU enters the lottery with 1 coupon per completed track (Anthropic certifications count once). Each GU draws 3 prizes at its tier: $200 (1st), $150 (2nd), $100 (3rd). All certified people also compete for 4 prizes of $50. Total: $1,550 USD.",
        positions: {
          1: "1st place — 3 prizes of $200 drawn among certified members",
          2: "2nd place — 3 prizes of $150 drawn among certified members",
          3: "3rd place — 3 prizes of $100 drawn among certified members",
        },
        empty: "No eligible people in this GU yet.",
        export: "Export CSV",
        exportGeneralPool: "Export general pool draw",
        notEnough: "Ranking does not have 3 GUs yet.",
        columns: {
          rank: "#",
          login: "Login",
          name: "Name",
          certifiedAt: "Certified at",
          cupons: "Coupons",
        },
      },
    },
    login: {
      subtitle: "The competition for agentic transformation at CI&T",
      loginPrompt: "Sign in to access the dashboard",
      signInButton: "Sign in with Google",
      authenticating: "Authenticating...",
      accessNote: "Only @ciandt.com employees have access",
    },
    loading: {
      data: "Loading data...",
      participants: "Loading participants list...",
      certifications: "Fetching certifications from University CI&T...",
      reconnecting: "Reconnecting your session...",
    },
    loadError: {
      title: "Could not load data",
      message: "Failed to fetch the participants list. Please try again.",
      retry: "Try again",
    },
    sessionExpired: {
      title: "Your session has expired",
      message: "For your security, your Google connection has expired. Reconnect to continue.",
      reconnect: "Reconnect",
    },
    rules: {
      crumb: { liga: "League", self: "Rules" },
      hero: {
        title: "Rules",
        subtitle: "Official Fase Pocket rules — Aug 3, 2026 to Sep 18, 2026",
      },
      toc: {
        title: "Contents",
        items: [
          "Objectives",
          "Organizing Committee",
          "Who Can Participate",
          "How to Participate",
          "Evaluation Criteria",
          "Disqualification Criteria",
          "Scoring System",
          "Awards",
          "FAQ",
          "General Provisions",
        ],
      },
      s1: {
        title: "Objectives",
        intro:
          "CI&T is investing in developing people in Agentic AI through structured certification tracks. To accelerate agentic AI adoption and transform our GUs into high-performance units, we created the Agentic League.",
        twoPhases:
          "The \"Fase Pocket\" is a special extension stage of the Agentic League. Its goal is to keep engagement high, introduce new official Anthropic content, and accelerate AI adoption company-wide through continuous learning.",
        phase1Label: "Fase Pocket (Aug 3 – Sep 18, 2026)",
        phase1Desc:
          "Keep engagement high, introduce new official Anthropic content, and accelerate AI adoption across the entire company through continuous learning.",
        scope:
          "This regulation applies exclusively to the Fase Pocket of the program.",
      },
      s2: {
        title: "Organizing Committee",
        members: [
          "Giovana Marconi",
          "Elen Reco de Oliveira",
          "Mateus Bahia",
          "Marília Varoni",
          "Rafael Franco Freitas",
          "Ana Paula Araujo Caixeta",
          "Rafael Bento Da Silva Soares",
          "Rodrigo Padula de Oliveira",
          "Davi Gonçalves Peterlini",
          "Vitoria Cavalaro Nogueira",
          "Maira Carvalho",
        ],
      },
      s3: {
        title: "Who Can Participate",
        eligibleTitle: "2.1 Eligible Audience",
        eligible: "All CI&T employees can take part in this certification journey.",
        notEligibleTitle: "Cannot participate:",
        notEligible: [
          "Agentic League organizing committee members",
          "Interns and third parties",
        ],
        requirementsTitle: "2.2 Mandatory Requirements",
        requirements: [
          "Have an active employment relationship with CI&T throughout the entire Fase Pocket period",
          "Be allocated to a GU/Area",
        ],
        registrationTitle: "2.3 Automatic Participation",
        registration:
          "All eligible people are already pre-qualified and have platform access enabled. There is no need to register — simply access the tracks and start whenever you like. Participation is entirely voluntary; only professionals active on the platform will accumulate points in the final count. To reward continuous effort and learning, all valid certifications obtained from May 29, 2026 onwards are already being counted toward this phase's scoreboard.",
      },
      s4: {
        title: "How to Participate",
        periodTitle: "3. Participation Period",
        period: "Start: August 3, 2026. End: September 18, 2026, at 18:00 (BRT).",
        deadline: "Certification deadline: September 18, 2026, at 18:00 (BRT).",
        tracksTitle: "4. Tracks and Scoring System",
        tracksIntro:
          "We have a total of 6 tracks/certifications available and everyone can complete them:",
        tracks: [
          {
            name: "Gen AI Engineering Fast Track",
            hours: "LinkedIn Learning",
            url: "https://www.linkedin.com/learning/paths/ci-t-gen-ai-engineering-fast-track",
            scoring: "70% = 250 pts · 100% + Certification = 500 pts",
          },
          {
            name: "Gen AI Orchestrator",
            hours: "LinkedIn Learning",
            url: "https://www.linkedin.com/learning/paths/ci-t-gen-ai-orchestrator-certification-pathway",
            scoring: "70% = 250 pts · 100% + Certification = 500 pts",
          },
          {
            name: "Gen AI Soft Skills",
            hours: "LinkedIn Learning",
            url: "https://www.linkedin.com/learning/paths/ci-t-soft-skills-certification-pathway?u=451056106",
            scoring: "70% = 250 pts · 100% + Certification = 500 pts",
          },
          {
            name: "Anthropic: Developer Foundations",
            hours: "Skilljar (Anthropic)",
            url: "https://anthropic-partners.skilljar.com/claude-certified-developer-foundations-certification",
            scoring: "Certification = 1,000 pts",
          },
          {
            name: "Anthropic: Architect Foundations",
            hours: "Skilljar (Anthropic)",
            url: "https://anthropic-partners.skilljar.com/claude-certified-architect-foundations-certification",
            scoring: "Certification = 1,000 pts",
          },
          {
            name: "Anthropic: Architect Professional",
            hours: "Skilljar (Anthropic)",
            url: "https://anthropic-partners.skilljar.com/claude-certified-architect-professional-certification",
            scoring: "Certification = 1,000 pts",
          },
        ],
        emailRuleTitle: "5. Rules",
        emailRule:
          "Use your @ciandt.com email throughout your certification journey on LinkedIn Learning, University, and Anthropic's course platform (Skilljar). Each registration with the CI&T domain reinforces our presence as a strategic Anthropic partner and counts toward our adoption metrics. For your track to be considered 100% complete in the game, your certificate must be recorded on the University platform.",
        emailRuleLinkLabel: "How to link your LinkedIn Learning account",
        emailRuleLinkUrl:
          "https://docs.google.com/presentation/d/1C6FTlfirU2pyCAoD08alcddgC32_Dj4rOpwMwKH1HVc/edit",
        supportTitle: "Access and Support",
        support: "Questions about the program can be answered here:",
        supportChannelLabel: "Channel:",
        supportChannel:
          "We don't have an official channel for the Fase Pocket of the Agentic League. If you have a question, check the announcements in the",
        supportChannelLinkLabel: "[Official CI&Ters] Internal Comms",
        supportChannelLinkUrl: "https://chat.google.com/room/AAAAMjpnSKc?cls=7",
        supportChannelSuffix:
          "group and use the thread to send your question, or reach out to one of the organizing committee members for support.",
        supportFaqLabel: "FAQ:",
        supportFaqSuffix: "Check the FAQ in this document.",
        supportFaqLinkLabel: "📢 AGENTIC LEAGUE: POCKET - OFFICIAL RULES + FAQ",
        supportFaqLinkUrl:
          "https://docs.google.com/document/d/1UAI8AdFeky0vzRXVusP1Xqd7Fr5-KWgD7qlXJWd7quI",
      },
      s5: {
        title: "Evaluation Criteria",
        validationTitle: "5.1 Completion Validation",
        validation: [
          "The track must be completed by Sep 18, 2026, at 18:00 BRT.",
          "Progress must be visible on the University platform (Talent — https://university.ciandt.com/).",
          "Tracks are only considered complete when certificates are generated by University (Talent) — for courses hosted there — or submitted to it, for external content, using the links indicated in the LinkedIn Learning tracks.",
          "Certification must be officially issued.",
          "The email used must be @ciandt.com.",
        ],
        exampleCaption: "Example of the link to submit external certificates",
        exampleCaptionQuiz: "Example of the link to a quiz on the University (Talent) platform",
        multiTitle: "5.2 Multiple Tracks",
        multi: "Each person can complete as many tracks as desired. All points accumulate for the GU.",
        progressTitle: "5.3 Progress Updates",
        progress:
          "Progress is updated every 2 days and can be tracked on the official League dashboard.",
        responsibilitiesTitle: "6. Responsibilities",
        responsibilities: [
          "Participant's responsibility: complete tracks, ensure @ciandt.com email is connected, and monitor progress on the dashboard.",
          "CI&T's responsibility: provide the progress tracking platform, update rankings weekly, and offer technical support.",
          "CI&T is not responsible for: individual access issues, internet connection problems, or progress lost if not saved on the platform.",
        ],
      },
      s6: {
        title: "Disqualification Criteria",
        intro: "Participants will be disqualified if they:",
        items: [
          "Use an email other than @ciandt.com for LinkedIn Learning registrations — since that makes it impossible for us to track progress.",
          "Commit proven fraud (certificate copying, data manipulation, etc).",
          "Violate CI&T's Code of Ethics.",
          "Have their employment relationship terminated before prize payment.",
        ],
      },
      s7: {
        title: "Scoring System",
        individualTitle: "8.1 Individual Scoring",
        individual: "Each person accumulates points based on track progress:",
        table: {
          headers: { track: "Track", at70: "70% complete", at100: "100% + Certification" },
          rows: [
            { track: "Engineering Fast Track", at70: "250 pts", at100: "500 pts" },
            { track: "Orchestrator Track", at70: "250 pts", at100: "500 pts" },
            { track: "Soft Skills Track", at70: "250 pts", at100: "500 pts" },
            { track: "Anthropic: Developer Foundations", at70: "—", at100: "1,000 pts" },
            { track: "Anthropic: Architect Foundations", at70: "—", at100: "1,000 pts" },
            { track: "Anthropic: Architect Professional", at70: "—", at100: "1,000 pts" },
          ],
        },
        notesTitle: "Notes",
        notes: [
          "Anthropic certifications count only once. That is, whether you complete one, two, or all three Anthropic certifications, you will earn the 1,000 pts in your final score only once.",
          "Points are cumulative (except for Anthropic certifications), so you can complete multiple tracks.",
          "Within the same track, 70% and 100% do not stack — the highest completion counts.",
        ],
        exampleTitle: "Example of individual scoring",
        exampleLines: [
          "Solange completes:",
          "Engineering 100% + certification = 500 pts",
          "Soft Skills 70% = 250 pts",
          "Anthropic: Architect Foundations = 1,000 pts (counted once)",
          "Anthropic: Architect Professional = already counted above",
        ],
        exampleTotal: "Solange's total: 1,750 pts",
        guTitle: "9.2 GU Scoring",
        guIntro:
          "To ensure fairness between smaller and larger GUs, the final score uses a formula with a logarithmic factor based on team size. This allows GUs with fewer people but high certification rates to compete with larger GUs. At the same time, the logarithm rewards absolute GU volume, curbing the unrealistic advantage of very small GUs.",
        formulaLabel: "Formula:",
        formula: "GU Points = [ (Individual Points / Eligible) × 100 ] × log10(Eligible)",
        guExampleTitle: "Practical example (GU Alpha vs GU Beta)",
        guExample: [
          "GU Alpha (50 members): 25 people × 1,500 pts = 37,500 pts → (37,500/50)×100 × log10(50) ≈ 127,500 Final Points.",
          "GU Beta (5 members): 4 people × 2,500 pts = 10,000 pts → (10,000/5)×100 × log10(5) ≈ 140,000 Final Points.",
          "Result: GU Beta (5 people) took 1st place because members aced the game; GU Alpha secured 2nd place with the formula rewarding the volume of 25 mobilized people.",
        ],
        tiebreakTitle: "Tiebreaker Criteria",
        tiebreakIntro:
          "If two GUs have the same final score, criteria will be applied in this order:",
        tiebreak: [
          "GU with more certified people (100% in at least 1 track).",
          "Chronological order (first GU to reach the score).",
        ],
        decimals: "Scores will use 2 decimal places.",
      },
      s8: {
        title: "Awards",
        intro: "The Fase Pocket awards are divided into 2 levels:",
        level1Title: "9.1 Level 1 — Recognition Badges",
        level1Intro:
          "Everyone earns digital badges based on track completions.",
        badgesIndividualTitle: "Specialization Badges",
        badgesIndividual: [
          {
            emoji: "💻",
            name: "Gen AI Engineering Master",
            req: "100% + Engineering Fast Track Certification",
            desc: "Mastered the Engineering Fast Track in Agentic AI.",
          },
          {
            emoji: "🎼",
            name: "Gen AI Orchestrator Master",
            req: "100% + Orchestrator Track Certification",
            desc: "Mastered the Orchestrator Track in Agentic AI.",
          },
          {
            emoji: "🧠",
            name: "Gen AI Soft Skills Master",
            req: "100% + Soft Skills Track Certification",
            desc: "Mastered essential skills for the agentic era.",
          },
          {
            emoji: "🐙",
            name: "Anthropic Certified",
            req: "Anthropic Certification",
            desc: "Official Anthropic certification: CCA-F, CCDV-F, CCAR-F and/or CCAR-P.",
          },
        ],
        badgesGuTitle: "Collaborative Badges (GU)",
        badgesGu: [
          {
            emoji: "🏆",
            name: "GU Champion",
            req: "Your GU ranked Top 3",
            desc: "Member of a winning GU in the Agentic League Fase Pocket.",
          },
          {
            emoji: "🎯",
            name: "GU Transformer",
            req: "Your GU reached 70%+ certification",
            desc: "Member of a GU that transformed 70%+ of the team.",
          },
          {
            emoji: "💪",
            name: "GU Outstanding",
            req: "Your GU reached 90%+ certification",
            desc: "Member of a GU with 90% or more certification.",
          },
        ],
        level2Title: "9.2 Level 2 — Financial Prizes (Top 3 GUs)",
        level2Intro:
          "The scoreboard will consider the 3 GUs with the highest scores (using the normalized formula) as the grand finalists of the Fase Pocket. People who earned at least 1 certification and belong to the Top 3 GUs will enter the prize lottery (three prizes per GU). In addition, all certified people — from any GU — compete for 4 prizes of $50 USD. Each fully completed certification (100%) equals 1 coupon (entry) in the lottery — the more tracks, the more chances to win.",
        prizes: [
          {
            place: "🥇 1st GU",
            top: "Lottery among certified members",
            per: "$200 USD per draw",
            total: "3 prizes of $200 USD",
          },
          {
            place: "🥈 2nd GU",
            top: "Lottery among certified members",
            per: "$150 USD per draw",
            total: "3 prizes of $150 USD",
          },
          {
            place: "🥉 3rd GU",
            top: "Lottery among certified members",
            per: "$100 USD per draw",
            total: "3 prizes of $100 USD",
          },
          {
            place: "🎁 Consolation",
            top: "All certified people",
            per: "$50 USD per draw",
            total: "4 prizes of $50 USD",
          },
        ],
        prizesTotal: "Total financial prizes: $1,550 USD",
        rulesTitle: "Lottery Rules",
        rules: [
          "Each fully completed (100%) certification equals 1 coupon (entry) in your GU's lottery.",
          "Anthropic certifications count once in the lottery (regardless of how many you complete).",
          "Any completed track qualifies you for the lottery — there is no restriction by track type.",
          "The winner must have an active employment relationship with CI&T at the time of payment.",
        ],
        paymentTitle: "Announcement and Payment",
        payment: [
          "Winners announcement: Sep 21, 2026.",
          "Payment method: in accordance with the legal rules of each country.",
          "Payment deadline: by Oct 21, 2026.",
          "Local currency conversion: exchange rate on payment date.",
        ],
      },
      faq: {
        title: "FAQ",
        intro:
          "Frequently asked questions about the Agentic League Fase Pocket.",
        linkLabel: "Open the Agentic League FAQ",
        linkUrl:
          "https://docs.google.com/document/d/1UAI8AdFeky0vzRXVusP1Xqd7Fr5-KWgD7qlXJWd7quI",
        items: [
          {
            q: "What is Agentic League?",
            a: "CI&T is investing in building people's skills in Agentic AI through structured certification tracks. To accelerate Agentic AI adoption and transform our GUs into high-performance units, we created the Agentic League — a gamification program that encourages training through a scoring and prize system.",
          },
          {
            q: "What is the Fase Pocket?",
            a: "The \"Fase Pocket\" is a special, intermediate extension stage of the Agentic League. Its goal is to keep engagement high, introduce new official Anthropic content, and accelerate AI adoption company-wide through continuous learning.",
          },
          {
            q: "How long does the Fase Pocket last?",
            a: "This stage runs from August 3, 2026 to September 18, 2026, at 18:00 (BRT).",
          },
          {
            q: "Is participation mandatory?",
            a: "No. Participation is entirely voluntary. If you choose not to participate, no action is needed — only professionals active on the platform will accumulate points.",
          },
          {
            q: "Are there other game phases?",
            a: "Yes. The Agentic League had Phase 1, which ran during June and July and was open only to P5 and P6 employees.",
          },
          {
            q: "Who can participate?",
            a: "All CI&T employees can participate, except: organizing committee members, interns, and third parties.",
          },
          {
            q: "Do I need to register?",
            a: "No. All eligible people are already automatically pre-qualified and have platform access enabled.",
          },
          {
            q: "Which tracks are available?",
            a: "We have 6 tracks/certifications in this phase: Gen AI Engineering Fast Track (500 pts at 100%), Gen AI Orchestrator (500 pts at 100%), Gen AI Soft Skills (500 pts at 100%), Anthropic - Developer Foundations (1,000 pts), Anthropic - Architect Foundations (1,000 pts), and Anthropic - Architect Professional (1,000 pts). Each person can complete as many tracks as they like. All points accumulate for the GU, except for Anthropic certifications, which count only once.",
          },
          {
            q: "Can I do more than one track?",
            a: "Yes! Points are cumulative. The more tracks you complete, the more points for your GU.",
          },
          {
            q: "Can I do more than one Anthropic certification? Do they add up in the score?",
            a: "You can complete as many certifications as you like, but for GU scoring, Anthropic certifications count 1,000 points only once. The maximum score one person can generate for the GU is 2,500 points.",
          },
          {
            q: "I work in Tech — can I do the Orchestrator track?",
            a: "YES! Everyone can do all tracks. There are no restrictions.",
          },
          {
            q: "I work in Management — can I do the Engineering track?",
            a: "YES! Everyone can do all tracks. There are no restrictions.",
          },
          {
            q: "How long do I have to complete the tracks?",
            a: "Until September 18, 2026, at 18:00 (BRT).",
          },
          {
            q: "What happens if I complete 70% of a track?",
            a: "You earn 250 points for your GU (except for Anthropic, which only awards points at 100%), but you do not qualify for financial prizes (only badges and symbolic recognition).",
          },
          {
            q: "Which track is worth the most points?",
            a: "The 3 Anthropic tracks are worth 1,000 pts each, but they count only once in the person's total score. The maximum score per person is 2,500 points.",
          },
          {
            q: "Can I start one track and switch to another?",
            a: "Yes! You can complete tracks in any order you like. Progress is captured based on submission to University.",
          },
          {
            q: "How do I know my certification has been validated?",
            a: "You can check our dashboard to see if your certification has been validated. Updates may take 1 to 2 days. For your track to be considered 100% complete, your certificate must be recorded on the University platform.",
          },
          {
            q: "How does the history of previously earned certificates work?",
            a: "To reward continuous learning, all valid certifications obtained from May 29, 2026 onwards are already being counted toward this Fase Pocket's scoreboard.",
          },
          {
            q: "Why do I need to use my @ciandt.com email?",
            a: "Because each @ciandt.com registration reinforces our presence as an Anthropic partner, counts toward adoption metrics, is trackable by the system, and is an official program requirement.",
          },
          {
            q: "I already started with a personal email — what now?",
            a: "Migrate before proceeding. Contact support on the Google Chat channel for guidance on how to migrate your account.",
          },
          {
            q: "How do I link my LinkedIn Learning account?",
            a: "Follow the official guide: [How to] LinkedIn Learning. If you have questions, ask in the support channel.",
          },
          {
            q: "I can't access LinkedIn Learning — what should I do?",
            a: "Check that your CI&T account is active, try logging in with @ciandt.com, clear your browser cache, and if the issue persists, report it in the support channel.",
          },
          {
            q: "Do I need to use @ciandt.com on the Anthropic platform too?",
            a: "YES! Use @ciandt.com on all registrations: LinkedIn Learning, University, and Skilljar (Anthropic's course platform).",
          },
          {
            q: "How does the financial prize work in this phase?",
            a: "In this phase, prizes focus on collective engagement. The scoreboard will consider the 3 GUs with the highest scores as finalists. Cash prizes will be drawn among people who earned at least 1 certification within those winning GUs. We will also run a broader lottery among all certified people across any GU, worth 4 prizes of $50 USD each. In every lottery, your chances are proportional to your effort: each fully completed (100%) certification equals 1 \"coupon\" in the draw. If you complete 4 certifications, your name enters the draw 4 times, multiplying your chances of winning! Except for Anthropic certifications, which count only once.",
          },
          {
            q: "What are the financial prize amounts?",
            a: "Each Top-3 GU draws three prizes at its tier: 1st Place (GU) — 3 prizes of $200 USD; 2nd Place (GU) — 3 prizes of $150 USD; 3rd Place (GU) — 3 prizes of $100 USD. In addition, all certified people (from any GU) compete for 4 prizes of $50 USD. Total: $1,550 USD.",
          },
          {
            q: "What about recognition badges?",
            a: "Everyone earns digital badges (Engineering Master, Orchestrator Master, Soft Skills Master, and Anthropic Certified) whenever they reach 100% of a track's requirements.",
          },
          {
            q: "When I change GUs, do my points come with me?",
            a: "Yes, points are individual and will follow you to the new GU.",
          },
          {
            q: "How does the lottery reward people who certified in more tracks?",
            a: "(The Golden Rule) Your lottery chances are proportional to your effort. Each fully completed (100%) certification equals 1 \"coupon\" in the draw. If you complete 4 certifications, your name enters your GU's draw 4 times, multiplying your chances of winning the prize! Except for Anthropic certifications, which count only once.",
          },
          {
            q: "How does GU scoring work?",
            a: "To ensure a fair competition, the GU's final score uses a logarithmic formula: [ (Total Individual Points / Total Eligible People) × 100 ] × log10(Total Eligible People).",
          },
          {
            q: "How do I see the ranking?",
            a: "Access the Agentic League dashboard to see the Top 10 GUs, your individual progress, and your GU's certification percentage.",
          },
          {
            q: "When is the ranking updated?",
            a: "It may take 1 to 2 days to be updated.",
          },
          {
            q: "Why isn't my progress showing on the dashboard?",
            a: "Possible reasons: you used an email other than @ciandt.com; the system hasn't synced yet (wait up to 2 days); you didn't complete all certificate submission steps on University; or there was a technical issue (report it in the support channel).",
          },
          {
            q: "Can I see other people's progress?",
            a: "Yes, on the dashboard you can see the names of all participants in your GU, each person's progress percentage, and the points accumulated.",
          },
          {
            q: "What happens in case of a tie?",
            a: "Tiebreaker criteria (in this order): 1) GU with more certified people (100%); 2) Chronological order (first to reach the score).",
          },
          {
            q: "Who earns badges?",
            a: "EVERYONE who completes 100% of at least 1 track. Badges are for recognition, not financial prizes.",
          },
          {
            q: "How many badges can I earn?",
            a: "It depends! If you complete 4 tracks = 4 specialization badges. If your GU finishes Top 3 = +1 GU Champion badge. Maximum of 7 badges if you meet all criteria.",
          },
          {
            q: "Can I add the badges to my LinkedIn?",
            a: "YES! We encourage you to add them to your profile. It reinforces your expertise and the CI&T × Anthropic partnership.",
          },
          {
            q: "Do badges expire?",
            a: "No! Badges are permanent. You can use them forever.",
          },
          {
            q: "Who wins the cash prize?",
            a: "From the Top 3 GUs with the highest scores, we will draw certified people within each GU. People with more certifications have more chances (every 1 certification = 1 chance to win). In addition, all certified people also compete for 4 prizes of $50 USD each.",
          },
          {
            q: "When do I receive the prize?",
            a: "Winners announcement: Sep 21, 2026. Payment deadline: by Oct 21, 2026. Local currency conversion: exchange rate on the payment date.",
          },
          {
            q: "How do I receive the prize?",
            a: "Awards may be delivered via vouchers or payroll, in accordance with each country's rules.",
          },
        ],
        whereToAskLabel: "Where can I get help?",
      },
      s9: {
        title: "General Provisions",
        acceptanceTitle: "11.1 Acceptance of Terms",
        acceptance:
          "By automatically participating in the program, the person declares awareness and agreement with all terms of these rules.",
        phase2Title: "11.2 Regulation Modifications",
        phase2:
          "The organizing committee reserves the right to adjust dates in case of force majeure (with 7 days' notice), modify technical criteria with prior communication, and cancel the program for exceptional reasons (with formal notification). Any modification will be communicated via email and on the Google Chat channel.",
        modificationsTitle: "11.3 Omitted Cases",
        modifications: [
          "Any situation not foreseen in these rules will be decided exclusively by the organizing committee.",
          "The committee's decisions are final and non-appealable.",
        ],
        modificationsNote:
          "Any modification will be communicated via email and on the Google Chat channel.",
        omissionsTitle: "11.4 Code of Ethics",
        omissions:
          "CI&T will not tolerate any action that aims to circumvent and/or defraud the program's rules. Violations of CI&T's Code of Ethics will result in immediate disqualification, formal report to HR, and possible disciplinary measures per internal policies. Important: participants must not enter or submit real data, CI&T proprietary code, confidential client data, or internal intellectual property into third-party AI learning platforms or certification exercises.",
        ethicsTitle: "11.5 Award Eligibility",
        ethics:
          "To be eligible to receive financial prizes, the winner must have an active employment relationship with CI&T on Oct 21, 2026 (payment date), must not be in a termination process, and must not have been disqualified under any criterion of these rules.",
        eligibilityTitle: "11.6 Questions",
      },
    },
  },
} as const;

type Widen<T> = T extends string
  ? string
  : T extends object
    ? { readonly [K in keyof T]: Widen<T[K]> }
    : T;
export type Translations = Widen<(typeof translations)["pt-BR"]>;
export default translations;
